import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage4UpDeksIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryPackage4UpDeksIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
